// Caixa "📅 Enviar para o My Planner" das listas de valores (Texto 3, C2), entre o resumo e a lista.
// Envia a lista inteira (inclusive os itens criados depois); enviada, oferece "Tirar do My Planner".
import { Pressable, Text, View } from 'react-native';
import type { AbaId } from '../store/types';
import { enviarListaAoPlanner, useListaNoPlanner } from '../lib/enviarPlanner';
import { C, alpha } from './theme';
import { t } from '../lib/i18n';

export function EnviarAoPlanner({ aba, lista, cor, aReceber }: { aba: AbaId; lista: string; cor: string; aReceber?: boolean }) {
  const enviada = useListaNoPlanner(aba, lista);
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10, padding: 12, borderRadius: 14, backgroundColor: enviada ? alpha(cor, 0.12) : C.card, borderWidth: 1, borderColor: alpha(cor, 0.4) }}>
      <Text style={{ fontSize: 20 }}>📅</Text>
      <View style={{ flex: 1 }}>
        <Text style={{ color: C.text, fontWeight: '700' }}>{enviada ? t('No My Planner') : t('Enviar para o My Planner')}</Text>
        <Text style={{ color: C.sub, fontSize: 12 }}>{aReceber ? (enviada ? t('Os valores a receber desta lista aparecem no My Planner, inclusive os novos.') : t('Envia só os valores a receber desta lista (as consultas já vão sozinhas), inclusive os novos.'))
          : enviada ? t('Todos os itens desta lista aparecem no My Planner, inclusive os novos.') : t('Envia todos os itens desta lista, inclusive os novos que forem criados depois.')}</Text>
      </View>
      <Pressable onPress={() => enviarListaAoPlanner(aba, lista, !enviada)} hitSlop={8}
        style={{ paddingVertical: 8, paddingHorizontal: 12, borderRadius: 10, backgroundColor: enviada ? 'transparent' : cor, borderWidth: 1, borderColor: cor }}>
        <Text style={{ color: enviada ? cor : '#fff', fontWeight: '700', fontSize: 13 }}>{enviada ? t('Tirar do My Planner') : t('Enviar')}</Text>
      </Pressable>
    </View>
  );
}
